var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('Header',{ref:"child",attrs:{"navtxt":_vm.$route.name,"headerOpacity":_vm.$route.meta.headerOpacity}}):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.payInfo.visible)?_c('pay',{attrs:{"payInfo":_vm.payInfo},on:{"close":_vm.closePay}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }